import { Component, inject, output } from '@angular/core';
import { SupplierContractStore } from '../../stores/supplier-contracts.store';
import { form, FormField } from '@angular/forms/signals';
import {
  SwitchBar,
  TooltipDirective,
  Select,
  Skeleton,
  Button,
  ToggleLabel,
  SimpleDialog,
  SimpleDialogLayout,
  Toggle,
  SwitchBarOption,
} from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { LocationsStore } from '../../../locations/store/locations.store';
import { LocationNamePipe } from '../../../locations/pipes/location-name-pipe';
import { SupplierContractsFilterFormSkeleton } from '../supplier-contracts-filter-form-skeleton/supplier-contracts-filter-form-skeleton';

@Component({
  selector: 'app-supplier-contracts-filter-form',
  imports: [
    SwitchBar,
    FormField,
    TooltipDirective,
    NgIcon,
    TranslocoPipe,
    Select,
    Skeleton,
    LocationNamePipe,
    Button,
    ToggleLabel,
    SimpleDialog,
    SimpleDialogLayout,
    Toggle,
    SwitchBarOption,
    SupplierContractsFilterFormSkeleton,
  ],
  templateUrl: './supplier-contracts-filter-form.html',
})
export class SupplierContractsFilterForm {
  private supplierContractStore = inject(SupplierContractStore);
  private locationsStore = inject(LocationsStore);

  changeFilter = output();

  protected filterForm = form(this.supplierContractStore.filter);

  protected years = this.supplierContractStore.years;
  protected yearsLoading = this.supplierContractStore.yearsLoading;

  protected locationsLoading = this.locationsStore.isLoading;
  protected locations = this.locationsStore.locations;

  protected onChangeFilter() {
    this.changeFilter.emit();
  }
}
